import React from 'react';
import {BrowserRouter, Route, Switch } from 'react-router-dom';
import ApolloClient from 'apollo-boost';
import route from './route';
import { 
    EditSurvey,MasterQuantityList,EditMasterQuantity,
    Masterevents,Masterparticipants,Dummyscreen,OrderManagementList,OrderManagementDetails,
    DashboardAnalytics,MasterRoles,BackofficeUsers,SurveyList,BrokersList,CommodityList,Products,
    EditBuysell,
    MasterCommodityList,News,Updates,ManageAds,LivePrices,ManageUsers,ManageRates,ManageBuy,EditUser,EditProduct,
    EditCommodity,EditNews,Livepriceummary,EditStoreprice,BuysellAnalytics,EditBroker,EditMasterCommodity,
    Login,Masterdepartments,  Configuration,Priceupdate,  OrderList, Masterspecialities,Spots,
    VisitorList,
    StallBookings,
    PrintSticker,


    MasterRoutes,MasterRepos,Masterlanguages,EditSubCommodity,SubCommodityList,RateProducts,EditUpdate,EditSpot,EditAds,Settings,EditStoreProduct,ManageFeedback,
    ManageRoleAccess,EditPermissions

} from '../screens';


import PrivateRoute from './PrivateRoute';
import {  NetworkProvider } from '../context/NetworkContext';
import { GlobalContext } from '../context';
import { ApolloProvider } from 'react-apollo';
import { ProductContext,ProductProvider } from '../context/ProductuploadContext';

const MainApp = () => {

    const { globalCtx } = React.useContext(GlobalContext);
    const { productCtx } = React.useContext(ProductContext);
    const client = new ApolloClient({ uri: globalCtx.gqlClient, });

    return(
        <ApolloProvider client={client} >
            {/* <ProductProvider > */}
            <NetworkProvider>
                <Switch>
                    <Route exact path="/" component={Login} />
                    <Route path={route.login} component={Login} />
                   
                    <PrivateRoute  path={route.masterroutes} component={MasterRoutes} />
                    <PrivateRoute  path={route.masterrepo} component={MasterRepos} />
                    <PrivateRoute  path={route.masterlanguages} component={Masterlanguages} />
                    <PrivateRoute  path={route.liveproducts} component={Products} />
                    <PrivateRoute  path={route.rateproducts} component={RateProducts} />
                    <PrivateRoute  path={route.commodity} component={CommodityList} />
                    <PrivateRoute  path={route.news} component={News} />
                    <PrivateRoute  path={route.updates} component={Updates} />
                    <PrivateRoute  path={route.spots} component={Spots} />
                    <PrivateRoute  path={route.addspot} component={EditSpot} />
                    <PrivateRoute  path={route.editupdate} component={EditUpdate} />
                    <PrivateRoute  path={route.addupdate} component={EditUpdate} />

                    
                    <PrivateRoute  path={route.settings} component={Settings} />
                    <PrivateRoute  path={route.manageroleaccess} component={ManageRoleAccess} />
                    <PrivateRoute  path={route.editpermissions} component={EditPermissions} />
                    <PrivateRoute  path={route.managefeedback} component={ManageFeedback} />

                    
                   
                   
                    <PrivateRoute  path={route.departments} component={Masterdepartments} />
                    <PrivateRoute  path={route.specialities} component={Masterspecialities} />
                    <PrivateRoute  path={route.events} component={Masterevents} />
                    <PrivateRoute  path={route.participants} component={Masterparticipants} />
                    <PrivateRoute  path={route.orderdetails} component={OrderManagementDetails} />
                    <PrivateRoute  path={route.orderlist} component={OrderManagementList} />
                    <PrivateRoute  path={route.dashboard} component={DashboardAnalytics} />
                    <PrivateRoute  path={route.edituser} component={EditUser} />
                    <PrivateRoute  path={route.editproduct} component={EditProduct} />
                    <PrivateRoute  path={route.editstoreproduct} component={EditStoreProduct} />
                    <PrivateRoute  path={route.addstoreproduct} component={EditStoreProduct} />

                    <PrivateRoute  path={route.addproduct} component={EditProduct} />
                    <PrivateRoute  path={route.editbroker} component={EditBroker} />
                    <PrivateRoute  path={route.addbroker} component={EditBroker} />
                    <PrivateRoute  path={route.editad} component={EditAds} />

                    <PrivateRoute  path={route.editbuysell} component={EditBuysell} />
                    <PrivateRoute  path={route.addbuysell} component={EditBuysell} />

                    
                    <PrivateRoute  path={route.editmastercommodity} component={EditMasterCommodity} />
                    <PrivateRoute  path={route.addmastercommodity} component={EditMasterCommodity} />

                    <PrivateRoute  path={route.editsubcommodity} component={EditSubCommodity} />
                    <PrivateRoute  path={route.addsubcommodity} component={EditSubCommodity} />
                    <PrivateRoute  path={route.subcommodity} component={SubCommodityList} />

                    
                    <PrivateRoute  path={route.masterroles} component={MasterRoles} />
                    <PrivateRoute  path={route.backofficeusers} component={BackofficeUsers} />
                    <PrivateRoute  path={route.survey} component={SurveyList} />
                    <PrivateRoute  path={route.brokers} component={BrokersList} />
                    <PrivateRoute  path={route.products} component={Products} />
                    <PrivateRoute  path={route.editspot} component={EditSpot} />

                    <PrivateRoute  path={route.manageads} component={ManageAds} />
                    <PrivateRoute  path={route.livelist} component={LivePrices} />
                    <PrivateRoute  path={route.userslist} component={ManageUsers} />
                    <PrivateRoute  path={route.visitors} component={VisitorList} />
                    <PrivateRoute  path={route.stallBookings} component={StallBookings} />
                    <PrivateRoute  path={route.printSticker} component={PrintSticker} />
                    <PrivateRoute  path={route.managerates} component={ManageRates} />
                    <PrivateRoute  path={route.managebuy} component={ManageBuy} />
                    <PrivateRoute  path={route.managesell} component={ManageBuy} />
                    <PrivateRoute  path={route.editcommodity} component={EditCommodity} />
                    <PrivateRoute  path={route.addcommodity} component={EditCommodity} />
                    <PrivateRoute  path={route.addnews} component={EditNews} />
                    <PrivateRoute  path={route.editnews} component={EditNews} />
                    <PrivateRoute  path={route.livesummary} component={Livepriceummary} />
                    <PrivateRoute  path={route.editstoreprice} component={EditStoreprice} />
                    <PrivateRoute  path={route.addstoreprice} component={EditStoreprice} />
                    <PrivateRoute  path={route.buyselldashboard} component={BuysellAnalytics} />

                    
                    
                    
                    <PrivateRoute  path={route.configuration} component={Configuration} />
                    
                    <PrivateRoute  path={route.dummyscreen} component={Dummyscreen} />

                    {/*******Survey group */}
                    <PrivateRoute  path={route.editsurvey} component={EditSurvey} />
                    {/*******Buy Sell group */}
                    <PrivateRoute  path={route.masterquantity} component={MasterQuantityList} />
                    <PrivateRoute  path={route.editquantity} component={EditMasterQuantity} />

          </Switch>
            </NetworkProvider>
            {/* </ProductProvider> */}
        </ApolloProvider>
    )
}


export default MainApp;